import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import cn from 'classnames';

import RichContent from '@components/RichContent/RichContent';
import RiskLevelButton from '@components/RiskLevelButton/RiskLevelButton';
import useAdminRiskLevelByProgramCodeAndId from '@store/hooks/useAdminRiskLevelByProgramCodeAndId';
import useSupplementCategoryById from '@store/hooks/useSupplementCategoryById';
import { getParsedText } from '@views/AdminInquiriesPage/AdminInquiryList/SupplementInquiryDetails/SupplementInformationForm/utils';
// TODO: Fix global component depends on local view one
import SupplementResponseDetailsField from '@views/InquiryResponsePage/SupplementResponseDetails/SupplementResponseDetailsBody/SupplementResponseDetailsField/SupplementResponseDetailsField';

import { IPrintResponseCardProps } from './PrintResponseCard.interface';

import './style.scss';

const PrintResponseCard: FC<IPrintResponseCardProps> = ({ className, item, programCode }) => {
  const { t } = useTranslation();

  const category = useSupplementCategoryById(item.supplementCategoryId);
  const riskLevel = useAdminRiskLevelByProgramCodeAndId(programCode, item.riskLevelId);

  return (
    <div className={cn('print-response-card', className)}>
      <div className="print-response-card__row print-response-card__header">
        <div className="print-response-card__name">{item.name}</div>

        {riskLevel && (
          <RiskLevelButton className="print-response-card__risk-level" riskLevel={riskLevel} />
        )}
      </div>

      <div className="print-response-card__row print-response-card__details">
        <div className="print-response-card__section">
          <SupplementResponseDetailsField
            className="print-response-card__item print-response-card_margin-t-0"
            label={t('inquiryResponse.company')}
          >
            {item.supplementCompanyName || '-'}
          </SupplementResponseDetailsField>
          <SupplementResponseDetailsField
            className="print-response-card__item print-response-card_margin-t-0"
            label={t('inquiryResponse.category')}
          >
            {category?.name || '-'}
          </SupplementResponseDetailsField>
          <SupplementResponseDetailsField
            className="print-response-card__item"
            label={t('inquiryResponse.drugClass')}
          >
            {item.drugClassNames?.join(', ') || '-'}
          </SupplementResponseDetailsField>

          <SupplementResponseDetailsField
            className="print-response-card__item"
            label={t('inquiryResponse.ingredients')}
          >
            {item.ingredientNames?.join(', ') || '-'}
          </SupplementResponseDetailsField>
        </div>
        <div className="print-response-card__section">
          <SupplementResponseDetailsField
            className="print-response-card_margin-t-0"
            label={t('inquiryResponse.comments')}
          >
            {item.comments ? <RichContent>{getParsedText(item.comments)}</RichContent> : '-'}
          </SupplementResponseDetailsField>
        </div>
      </div>

      <div className="print-response-card__row">
        <SupplementResponseDetailsField
          className="print-response-card_margin-t-0 print-response-card__link"
          label={t('inquiryResponse.viewProductPage')}
        >
          {item.productLink || '-'}
        </SupplementResponseDetailsField>
      </div>
    </div>
  );
};

export default PrintResponseCard;
